import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ConstantsKey } from 'app/shared/constant/constants-keys';
import { ISICCardService } from "app/modules/isic-card/services/isic-card.service";
import Swal from "sweetalert2";

@Component({
  selector: 'isic-card',
  templateUrl: './isic-card.component.html',
  styleUrls: ['./isic-card.component.scss'],
  encapsulation: ViewEncapsulation.None
  // styleUrls:['../../../../../@core/scss/base/pages/app-ecommerce-details.scss']
})
export class IsicCardComponent implements OnInit { 
  public showMoreContents : boolean = false;
  public showLoader: boolean = false;

  public menuItems = [
    {
      'icon': 'isic1.png',
      'title': 'Global Student Identity Proof',
      'url': '',
    },
    {
      'icon': 'isic2.png',
      'title': 'Exclusive Discounts Worldwide',
      'url': '',
    },
    {
      'icon': 'isic3.png',
      'title': 'Travel and Accommodation Perks',
      'url': '',
    },
    {
      'icon': 'isic4.png',
      'title': 'Digital Card for Convenience',
      'url': '',
    },
    {
      'icon': 'isic5.png',
      'title': 'Special Versions for Teachers',
      'url': '',
    },
 
  ];
  public specItems = [
    {
      'icon': 'spec1.png',
      'title': 'For Full-Time Students Only',
      'url': '',
    },
    {
      'icon': 'spec2.png',
      'title': 'Annual Renewal Required',
      'url': '',
    },
    {
      'icon': 'spec3.png',
      'title': 'Valid for One Year',
      'url': '',
    },
    {
      'icon': 'spec4.png',
      'title': 'Proof of Enrollment Needed',
      'url': '',
    },
    {
      'icon': 'spec5.png',
      'title': 'Apply Online or Through Partners',
      'url': '',
    },
  ]

  public activeTab: string = "";
  constructor(
    public router: Router,
    public isicCardService: ISICCardService
  ) {}
  

  ngOnInit() {
    this.showLoader = true;
    this.isicCardService.isicApplicationStatus().subscribe(
      (res) => {
        this.showLoader = false;
        console.log(" RESPONSE == ", res.body);
        let respObj = res.body;
        if (!respObj) {
          
          // this.router.navigate(["/isicCard"]);
        } else if (respObj && respObj["isicCardStatus"] == "IN_PROCESS") {
          Swal.fire( "Your application is under process, Please try after sometime!!!");
        } else if ( respObj && respObj["isicCardStatus"] == "VALID") {
          sessionStorage.setItem( ConstantsKey.ISIC_STATUS_DATA, JSON.stringify(respObj) );
          this.router.navigate(["/link-isic-card"]);
        }/*  else if ( respObj && respObj["isicCardStatus"] == "ACTIVE" && respObj["photoStatus"] == "UPLOAD") {
          sessionStorage.setItem(
            ConstantsKey.ISIC_STATUS_DATA,
            JSON.stringify(respObj)
          );
          this.router.navigate(["/link-isic-card"]);
        } */

        // this.router.navigate(['/isicCard']);
      },
      (err) => {
        this.showLoader = false;
      }
    );



  }
  setActiveTab(tabIndex) {
    this.activeTab = tabIndex;
  }
  goToNewFeatures() {
    this.router.navigate(['/newfeatures']);
  }
  // showContents(){
  //   this.showMoreContents = true;
  //   this.buttonText = 'View Less';
  // }

  // hideContents(){
  //   this.showMoreContents = false;
  //   this.buttonText = 'View More';
  // }

  goToISICForm() {
    sessionStorage.removeItem(ConstantsKey.ISIC_STATUS_DATA);
    this.router.navigate(['/link-isic-card']);
  }

}
